import "./styles.css";
import { useEffect, useState } from "react";
import { useBreakpoints } from "../../hooks";
import Drawer from "./Drawer";
import ModalDrawer from "./ModalDrawer";
import Rail from "./Rail";
import FloatingButton from "./FloatingButton";
import { useAccount } from "../../AccountContext";
import { Link } from "react-router-dom";
import s from "./NoAuthMenubar.module.css";

function MenuBar() {
  const breakpoint = useBreakpoints();
  const [showDrawer, setShowDrawer] = useState(false);
  const [showRail, setShowRail] = useState(false);
  const [showModalDrawer, setShowModalDrawer] = useState(false);
  const [showMenuButton, setShowMenuButton] = useState(false);
  const { account } = useAccount();

  useEffect(() => {
    switch (breakpoint) {
      case "xxl":
      case "xl":
        setShowDrawer(true);
        setShowRail(false);
        setShowModalDrawer(false);
        setShowMenuButton(false);
        break;
      case "lg":
      case "md":
      case "sm":
        setShowDrawer(false);
        setShowRail(true);
        setShowModalDrawer(false);
        setShowMenuButton(false);
        break;
      case "xs":
      default:
        setShowDrawer(false);
        setShowRail(false);
        setShowModalDrawer(false);
        setShowMenuButton(true);
    }
  }, [breakpoint]);

  const handleMenuButtonClick = () => {
    switch (breakpoint) {
      case "xxl":
      case "xl":
        setShowDrawer(!showDrawer);
        setShowRail(!showRail);
        break;
      case "lg":
      case "md":
      case "sm":
      case "xs":
      default:
        setShowModalDrawer(true);
    }
  };
  // useInterval(() => {
  //   queryClient.invalidateQueries("alerts");
  // }, 60 * 1000);

  if (!account) {
    return (
      <div className={s.root}>
        <header className={s.header}>
          <a href="/">
            <AnimatedLogo size={140} withText={false} />
          </a>
          <nav>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/support">Support</Link>
              </li>
              <li>
                <Link to="/policies">Terms</Link>
              </li>
              <li>
                <Link to="/resources">Artwork</Link>
              </li>
              <li>
                <a
                  href="https://accounts.anglicanchurch.nz"
                  target="_blank"
                  rel="noreferrer"
                >
                  Anglican Account
                </a>
              </li>
            </ul>
          </nav>
        </header>
      </div>
    );
  }

  return (
    <>
      {showDrawer && <Drawer onMenuButtonClick={handleMenuButtonClick} />}
      {showRail && <Rail onMenuButtonClick={handleMenuButtonClick} />}
      {showModalDrawer && (
        <ModalDrawer onMenuButtonClick={() => setShowModalDrawer(false)} />
      )}
      {showMenuButton && (
        <FloatingButton onMenuButtonClick={handleMenuButtonClick} />
      )}
    </>
  );
}

export default MenuBar;

function AnimatedLogo({ withText = true, size = 256 }) {
  return (
    <div
      style={{ width: size, height: size, margin: size * -0.17 }}
      className="relative block"
    >
      <TuiaLogoSquare
        width={size}
        height={size}
        className="absolute top-0 left-0"
      />
    </div>
  );
}
export function TuiaLogoSquare(props) {
  return (
    <svg
      width="256"
      height="256"
      viewBox="0 0 3000 3000"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
      {...props}
    >
      <path fill="none" d="M0 0h3000v3000H0z" />
      <path
        d="M1937.59 1589.59c-61.598 25.015-117.214 59.623-163.13 99.614-46.042-40.102-101.839-74.788-163.642-99.823 83.72-58.726 91.7-151.51 91.7-182.78 0-111.775-90.747-202.522-202.522-202.522-111.775 0-202.522 90.747-202.522 202.522 0 31.27 7.98 124.054 91.7 182.78-61.802 25.033-117.599 59.721-163.642 99.823-45.916-39.993-101.531-74.596-163.13-99.614 83.32-58.52 91.188-151.765 91.188-182.989 0-111.775-90.747-202.522-202.521-202.522-111.775 0-202.522 90.747-202.522 202.522 0 31.18 7.933 123.518 90.965 182.259-155.037 63.003-280.091 202.306-280.091 457.44 0 20.696 16.803 37.5 37.5 37.5s37.5-16.804 37.5-37.5c0-259.125 150.756-378.381 316.497-413.06 85.091 18.495 162.529 58.685 221.767 109.354l-2.198 2.608c-51.273 61.566-80.326 130.256-80.326 195.021 0 86.424 62.263 145.106 135.394 145.106 73.135 0 135.348-58.677 135.348-145.106 0-64.765-29.052-133.455-80.325-195.021l-2.199-2.608c59.204-50.641 136.59-90.813 221.617-109.321 85.036 18.511 162.415 58.684 221.617 109.321l-2.199 2.608c-51.273 61.566-80.325 130.256-80.325 195.021 0 86.424 62.262 145.106 135.393 145.106 73.136 0 135.349-58.677 135.349-145.106 0-64.765-29.053-133.455-80.326-195.021l-2.198-2.608c59.236-50.668 136.675-90.857 221.767-109.354 165.741 34.679 316.497 153.935 316.497 413.06 0 20.696 16.803 37.5 37.5 37.5s37.5-16.804 37.5-37.5c0-255.134-125.054-394.437-280.091-457.44 83.032-58.741 90.965-151.079 90.965-182.259 0-111.775-90.747-202.522-202.522-202.522-111.774 0-202.521 90.747-202.521 202.522 0 31.224 7.868 124.469 91.188 182.989zm-712.058 206.76c-37.361 45.827-60.371 95.862-60.371 143.873 0 40.295 26.297 70.106 60.394 70.106 34.094 0 60.348-29.815 60.348-70.106 0-48.011-23.01-98.046-60.371-143.873zm548.928 0c-37.361 45.827-60.371 95.862-60.371 143.873 0 40.295 26.296 70.106 60.393 70.106 34.094 0 60.349-29.815 60.349-70.106 0-48.011-23.01-98.046-60.371-143.873zm274.319-239.76c116.694-27.326 127.666-122.551 127.666-149.989 0-70.381-57.14-127.522-127.522-127.522-70.381 0-127.521 57.141-127.521 127.522 0 27.407 10.656 123.544 127.377 149.989zm-1097.57 0c116.721-26.445 127.377-122.582 127.377-149.989 0-70.381-57.14-127.522-127.521-127.522-70.382 0-127.522 57.141-127.522 127.522 0 27.438 10.972 122.663 127.666 149.989zm548.783-.035c116.558-27.368 127.522-122.527 127.522-149.954 0-70.381-57.141-127.522-127.522-127.522s-127.522 57.141-127.522 127.522c0 27.427 10.964 122.586 127.522 149.954z"
        fill="url(#prefix___Radial1)"
      />
      <defs>
        <radialGradient
          id="prefix___Radial1"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-119.733 1825.515 334.333) scale(2401.49)"
        >
          <stop offset={0} stopColor="#09f" />
          <stop offset={1} stopColor="#00e6d2" />
        </radialGradient>
      </defs>
    </svg>
  );
}
